import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgFlagFill = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M5.4502 2.55859C6.41379 2.28838 7.89659 2.21173 9.92285 3.07715C11.7793 3.87188 13.2288 3.96217 14.2393 3.83398C14.7423 3.77014 15.1312 3.65321 15.4014 3.54688C15.5362 3.4938 15.6417 3.44363 15.7168 3.4043C15.7543 3.38468 15.7843 3.36757 15.8066 3.35449C15.8188 3.34733 15.833 3.3386 15.8389 3.33496L15.8496 3.32812L15.8594 3.32129C15.8944 3.2977 15.9446 3.29379 15.9854 3.31445C16.0275 3.33712 16.0527 3.38052 16.0527 3.42578V11.4277C16.0527 11.4689 16.032 11.507 15.9961 11.5312L15.9922 11.5352C16.0037 11.5272 13.8138 13.0149 9.82422 11.3076C6.84431 10.0334 5.06851 10.8457 4.41504 11.2939L4.19824 11.4434V17.501C4.19821 17.5698 4.14208 17.626 4.07324 17.626C4.00441 17.626 3.94828 17.5698 3.94824 17.501V3.40723C3.94829 3.39042 3.95178 3.37433 3.95801 3.35938L3.98535 3.31836C4.01993 3.28476 4.50749 2.82301 5.4502 2.55859Z",
		fill: "#FF2411",
		stroke: "#FF2411"
	})
});
export default SvgFlagFill;
